import { createSlice } from "@reduxjs/toolkit";

const { reducer, actions } = createSlice({
    name: "routes",
    initialState: {
        positions: {},
    },
    reducers: {
        addPositions(state, action) {
            state.positions = action.payload;
        },
        deletePositions(state, _action) {
            state.positions = {};
        },
    },
});

export { actions as routesActions };
export { reducer as routesReducer };
